import { gql, useSubscription } from '@apollo/client'

export const LAB_TEST_WIDGET_SUBSCRIPTION = gql`
  fragment LabTestFields on DashboardLabTestEntry {
    orderDate
    patient {
      id
    }
    testLogs {
      id
      name
      statusId
      notes
      date
      labType
      labVendor
      businessId
    }
    vet {
      id
      firstName
      lastName
    }
    order {
      id
      externalId
      status {
        id
        name
      }
      date
      pdfUrl
      soap {
        id
      }
      iframeUrl
      notes
      orphan
      result {
        id
        pdfUrl
        externalId
        date
        iframeUrl
      }
    }
    vendor {
      id
      name
    }
    uniqueIdentifier
    soap {
      id
    }
    invoice {
      id
    }
    appointment {
      id
      scheduledStartDatetime
      businessAppointmentType {
        id
        name
      }
      businessId
    }
  }

  subscription LabTestWidget(
    $patientId: ID!
    $offset: PageOffset = 0
    $limit: PageLimit = 5
  ) {
    labTestWidget(patientId: $patientId, offset: $offset, limit: $limit) {
      completedLabTests {
        ...LabTestFields
      }
      inProgressLabTests {
        ...LabTestFields
      }
      resultsReceivedLabTests {
        ...LabTestFields
      }
      labTestCounters {
        completedLabTests
        inProgressLabTests
        resultsReceivedLabTests
      }
    }
  }
`

export const useLabTestWidgetSubscription = (
  patientId: string,
  offset: number = 0,
  limit: number = 5,
) =>
  useSubscription(LAB_TEST_WIDGET_SUBSCRIPTION, {
    variables: { patientId, offset, limit },
    skip: !patientId,
  })
